import {IconDone} from '@sportcast/ui-react';
import {CookieConsent} from 'react-cookie-consent';
import {Trans, useTranslation} from 'react-i18next';
import './CookieBanner.scss';

export const CONSENT_TECHNICAL_COOKIES = 'CONSENT_TECHNICAL_COOKIES';

function CookieBanner() {
    const [t] = useTranslation();
    return (
        <CookieConsent
            location="bottom"
            buttonText={<span className="button-content">
                <IconDone className="button-icon"/>{t('Consent.BUTTON_TEXT')}</span>}
            declineButtonText={t('Consent.DECLINE_BUTTON_TEXT')}
            cookieName={CONSENT_TECHNICAL_COOKIES}
            expires={300}
            contentClasses="consent-content"
            buttonWrapperClasses="consent-buttons"
            buttonClasses="consent-button"
        >
            <p className="consent-text">
                <Trans i18nKey="Consent.TEXT" components={{
                    1: <a href={`${window.environment.legalUrl}data-privacy`} target="_blank"
                          rel="noreferrer">{t('footer.PRIVACY_POLICY')}</a>
                }}/>
            </p>
        </CookieConsent>
    );
}

export default CookieBanner;
